module.exports = __webpack_public_path__ + "media/images/seeds/Yasser-1f501784f397f2b0f24b4986df6f3c77.jpg";